/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface StructureHistoryState {
  canUndo: boolean;
  canRedo: boolean;
}

const initialState: StructureHistoryState = {
  canUndo: false,
  canRedo: false
};

const structureHistorySlice = createSlice({
  name: 'structureHistory',
  initialState,
  reducers: {
    setCanUndo: (state, action: PayloadAction<boolean>) => {
      state.canUndo = action.payload;
    },
    setCanRedo: (state, action: PayloadAction<boolean>) => {
      state.canRedo = action.payload;
    }
  }
});

export const { setCanUndo, setCanRedo } = structureHistorySlice.actions;
export default structureHistorySlice.reducer;
